import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, DialogContent, Tooltip } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { typeDate } from 'components/mui/Formatters';
import { ModalActionProps } from 'models/AutoModals';
import { ActivityModel } from 'models/ActivityModel';


type ActivityDialogProps = {
    activity: ActivityModel[],
} & ModalActionProps

const ActivityDialog = ({activity}: ActivityDialogProps) => {
    const {t} = useTranslation('cars');

    const columns: GridColDef<ActivityModel>[] = [
        {
            field: 'id',
            headerName: '#',
            width: 70,
        },
        {
            field: 'causer',
            headerName: t('name'),
            width: 190,
            valueFormatter: params => params.value.name
        },
        {
            field: 'event',
            headerName: t('event'),
            width: 100,
        },
        {
            field: 'old',
            headerName: t('old'),
            flex: 1,
            renderCell: params => params.row.properties.old && <Tooltip
                title={renderList(params.row.properties.old)}
                placement="left"
            >
                <Box>{renderText(params.row.properties.old)}</Box>
            </Tooltip>,
        },
        {
            field: 'attributes',
            headerName: t('attributes'),
            flex: 1,
            renderCell: params => params.row.properties.attributes && <Tooltip
                title={renderList(params.row.properties.attributes)}
                placement="left"
            >
                <Box>{renderText(params.row.properties.attributes)}</Box>
            </Tooltip>,
        },
        {
            field: 'batch',
            headerName: t('batch'),
            type: 'boolean',
        },
        {
            field: 'created_at',
            headerName: t('date'),
            width: 100,
            ...typeDate,
        },
    ];

    const renderList = (json: Record<string, string>) => Object.entries(json)
        .map(([key, val]) => <Box key={key}>{key}: {val}</Box>);

    const renderText = (json: Record<string, string>) => Object.entries(json)
        .map(([key, val]) => `${key}: ${val}`)
        .join(', ');

    return (
        <DialogContent sx={{height: '60vh'}}>
            <DataGrid
                rows={activity}
                columns={columns}
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnMenu
                pageSizeOptions={[100]}
            />
        </DialogContent>
    );
};

export default ActivityDialog;
